import { IVideo } from '../types'

/**
 * RESH13-1138
 * The upload interface appends the orientation to the reference id
 * (`...-part-01-vertical`). qdata has no orientation field yet, so the
 * suffix is the only marker available on the client - once the API exposes
 * the orientation, only this function has to change.
 */
const VERTICAL_REF_SUFFIX = '-vertical'

export const isVerticalVideoRef = (videoRef?: string | null): boolean =>
  !!videoRef && videoRef.trim().toLowerCase().endsWith(VERTICAL_REF_SUFFIX)

export const isVerticalVideo = (video?: IVideo | null): boolean =>
  isVerticalVideoRef(video?.name)

/**
 * RESH13-1138
 * A poster meant for a 16:9 player is delivered already cropped to it - the
 * one of a body video comes out of the editor as t_app_16x9, 800x450 - so
 * showing it in a 9/16 frame blows it up and cuts most of it away. Swapping
 * the transformation makes Cloudinary crop the same asset for the vertical
 * frame instead, with the face detection its named transformation carries.
 *
 * Follows clearImageTransformations: everything between /upload/ and the
 * version segment is the transformation. A url shaped otherwise is left alone,
 * and one that already asks for the vertical crop simply stays as it is.
 */
const VERTICAL_POSTER_TRANSFORMATION = 't_poster_vertical'

export const verticalPosterUrl = (url?: string | null): string =>
  (url || '').replace(
    /(\/upload\/)(.*?)(v\d+\/)/,
    `$1${VERTICAL_POSTER_TRANSFORMATION}/$3`
  )
